import Vuex from 'vuex';
import { getAppConfig } from 'larasnap';
import { pipe } from 'larasnap/support';

export default class {
    _appProps; // Data passed to the vue app that will need to be passed on to the state function
    _components; // All the components that make up a Vuex Store (getters, mutations, etc...)
    _pseudoModules = [];
    _inject = {};

    constructor(appProps, components) {
        this._appProps = appProps;
        this._components = components;

        if (components.pseudoModules) {
            this._pseudoModules = components.pseudoModules;
            delete components.pseudoModules;
        }
        if (components.inject) {
            this._inject = components.inject;
            delete components.inject;
        }

        this._pseudoModules.forEach(this.mergePseudoModule.bind(this));
    }

    mergePseudoModule(pseudoModule) {
        ['getters', 'mutations', 'actions'].forEach(type => {
            Object.assign(this._components[type], pseudoModule[type]);
        });
    }

    createStateFunc() {
        const data = JSON.parse(JSON.stringify(this._appProps));

        if (!this._components.state) {
            this._components.state = x => x;
        }

        return pipe(
            this._components.state.bind(this, data),
            ...this._pseudoModules.filter(x => x.state).map(x => x.state),
        );
    }

    create() {
        const store = new Vuex.Store({
            ...this._components,
            state: this.createStateFunc(),
        });

        if (getAppConfig('debug')) {
            console.log('VuexState', store.state);
        }

        for (const name in this._inject) {
            store[name] = this._inject[name](store);
        }

        return store;
    }
}
